export default {
  onlineStatus: null,
  products: [],
  productBadges: [],
  allAttributes: [],
  debugMsg: '',
  emptyObject: {
    productCode: '',
    productCodeAttributes: [],
    productCodeId: null,
    productStock: 0,
    productActive: false
  },
  config: {
    showInactiveProductCodes: false,
    googleMapsApiKey: '',
    googleMapsDefaultLocationCenter: ''
  },
  cart: {
    cartContents: [],
    giftContents: [],
    giftRules: [],
    cartErrors: [],
    defaultCoupon: {
      couponCode: '',
      couponDiscount: 0,
      couponName: null
    },
    liveData: []
  },
  emptyProduct: {
    productId: '',
    productUrl: '',
    productName: '',
    images: {
      0: [{
        is_main: '1',
        original: '/files/products/no_photo.jpg',
        small: '/files/products/no_photo.jpg',
        medium: '/files/products/no_photo.jpg',
        large: '/files/products/no_photo.jpg'
      }]
    },
    productImage: 'no-image.jpg',
    productBadge: '0',
    productWeight: '0',
    productDescription: '',
    productPoints: 0,
    productHasDiscount: false,
    productDisclosure: '',
    productOldPrice: '00',
    productFinalPrice: '0',
    availableFrom: '',
    availableUntil: '',
    productStock: 0,
    barCodes: [''],
    productCodes: [
      {
        productCode: '',
        productStock: 1,
        productCodeId: null,
        productActive: false,
        productCodeAttributes: []
      }
    ],
    vendorName: '',
    vendorLogo: 'no-image.jpg',
    noImage: '/ui/front/img/no_photo.jpg'
  },
  productCardModal: {
    open: false,
    productId: null
  },
  noImage: '/ui/main/img/no_photo.jpg',
  selectedProductCodeId: null,
  selectedAttributeId: null,
  selectedGifts: {},
  transporterRequiredData: {
    county: '',
    country: '',
    postalCode: '',
    totalWithVat: 0,
    weight: 0
  },
  transporters: [],
  previewOrderData: {},
  minicartGiftChoiceModal: false,
  selectedTransporterId: '',

  // Smart Point Service
  allTransporterSmartPoints: {},
  smartPointLoading: false,
  smartPointIsSelected: false,

  uriWithoutOffset: '',
  isTopLevelCategory: false,
  currentPageNumber: null,
  productCategoryData: [],

  searchInputSmartPoints: '',
  maxResultsSmartPoints: 20,
  closestSmartPoints: {},
  cachedFilteredSearchedClosestSmartPoints: {},
  selectedSmartPoint: null,
  previousPostalCodeInput: '',
  googleMapLoading: true,
  mapPoints: [],
  googleService: {},
  currentUserGeolocation: '',
  currentUserGeolocationError: '',
  checkoutLocalErrors: {},
  vatError: false,
  checkoutVatApiDebounceTimeout: null,
  selectedCurrency: [],
  afterAddToCartRecommendation: {
    products: [],
    openModal: false,
    requestRecommendation: true
  },
  activeTagFilters: [],
  tagRecordsUsed: [],
  filterQueryStringVar: '',
  listingTagGroupCombos: [],
  externalTransporterRates: [],
  externalTransporterRatesLoading: false,
  selectedTransporterExternalRate: null,
  isCustomerLoggedIn: false,
  giftPackaging: false,
  giftPackagingMessage: ''
}
